export const generate_timestamp = () => {
  const date = new Date()
    .toLocaleString()
    .replace(/\//g, '-')
    .replace(/:/g, '-')
  return date
}



// WEBPACK FOOTER //
// ./src/utils/timestamp.js